/**
 * GT THRONE — Animations JS
 * Scroll-driven animations for homepage sections
 * Loaded on every page via theme.liquid (deferred)
 *
 * Behaviors:
 * 1. Zoom Parallax — scale images on scroll
 * 2. FX Scroll — background swap, word mask, progress bar
 * 3. Social Feedback — text split + card fan-out
 */

(function () {
  'use strict';

  /**
   * Utility: get scroll progress within a section (0 to 1)
   */
  function getScrollProgress(section) {
    var rect = section.getBoundingClientRect();
    var sectionH = section.offsetHeight - window.innerHeight;
    var scrolled = -rect.top;
    return Math.min(Math.max(scrolled / sectionH, 0), 1);
  }

  /* ---- 1. ZOOM PARALLAX ---- */
  (function initZoomParallax() {
    var section = document.querySelector('.zoom-parallax');
    if (!section) return;
    if (window.innerWidth <= 768) return;

    var items = section.querySelectorAll('.zoom-parallax__item');
    var scaleTargets = [4, 5, 6, 5, 6, 8, 9];
    /* Hold phase: keep scale=1 until the sticky pins and images are fully composed in view */
    var HOLD_END = 0.3;

    function update() {
      var progress = getScrollProgress(section);
      var zoomProgress =
        progress < HOLD_END ? 0 : (progress - HOLD_END) / (1 - HOLD_END);
      items.forEach(function (item, i) {
        var target = scaleTargets[i % scaleTargets.length];
        var scale = 1 + (target - 1) * zoomProgress;
        item.style.transform = 'scale(' + scale + ')';
      });
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('load', update);
  })();

  /* ---- 2. FX SCROLL ----
     Scroll-driven slider: the section is 400vh tall with a 100vh sticky
     child, so position:sticky pins it for ~300vh of scroll. As the user
     scrolls through that range we map scroll progress (0-1) to a slide
     index, so the section stays visible until all slides are shown. */
  (function initFxScroll() {
    var section = document.querySelector('.fx-scroll-section');
    if (!section) return;
    if (window.innerWidth < 990) return;

    var bgSlides = section.querySelectorAll('.fx-bg-slide');
    var titles = section.querySelectorAll('.fx-title');
    var leftItems = section.querySelectorAll('.fx-col--left .fx-list-item');
    var rightItems = section.querySelectorAll('.fx-col--right .fx-list-item');
    var progressFill = section.querySelector('.fx-progress-fill');
    var progressCurrent = section.querySelector('.fx-progress-current');
    var totalSlides = bgSlides.length;
    if (!totalSlides) return;

    var currentIndex = 0;

    /* Split each title's <h3> text into per-word mask wrappers so the
       words can slide independently. Done once on init. */
    titles.forEach(function (titleEl) {
      var h3 = titleEl.querySelector('h3');
      if (!h3) return;
      var words = h3.textContent.trim().split(/\s+/);
      h3.innerHTML = '';
      words.forEach(function (word, i) {
        var wrap = document.createElement('span');
        wrap.className = 'fx-word-wrap';
        var inner = document.createElement('span');
        inner.className = 'fx-word-inner fx-in';
        inner.textContent = word;
        wrap.appendChild(inner);
        h3.appendChild(wrap);
        if (i < words.length - 1) h3.appendChild(document.createTextNode(' '));
      });
    });

    /* Inactive titles start pre-positioned below so the first forward
       slide-change reveals them sliding up into place. */
    titles.forEach(function (titleEl, idx) {
      if (idx === 0) return;
      titleEl.querySelectorAll('.fx-word-inner').forEach(function (w) {
        w.classList.remove('fx-in');
        w.classList.add('fx-ready-below');
      });
    });

    function setSlide(index) {
      if (index < 0 || index >= totalSlides) return;
      if (index === currentIndex) return;
      var prevIndex = currentIndex;
      var goingDown = index > currentIndex;
      currentIndex = index;

      bgSlides.forEach(function (s, i) {
        s.classList.toggle('fx-bg-slide--active', i === index);
      });
      leftItems.forEach(function (l, i) {
        l.classList.toggle('fx-list-item--active', i === index);
      });
      rightItems.forEach(function (r, i) {
        r.classList.toggle('fx-list-item--active', i === index);
      });
      if (progressFill) {
        progressFill.style.width =
          (index / Math.max(totalSlides - 1, 1)) * 100 + '%';
      }
      if (progressCurrent) {
        progressCurrent.textContent = '0' + (index + 1);
      }

      /* Outgoing words: slide off in the scroll direction. */
      var outTitle = titles[prevIndex];
      var outWords = outTitle ? outTitle.querySelectorAll('.fx-word-inner') : [];
      outWords.forEach(function (w) {
        w.classList.remove('fx-in', 'fx-ready-below', 'fx-ready-above');
        w.classList.add(goingDown ? 'fx-out-up' : 'fx-out-down');
      });

      /* Incoming words: pre-position opposite the scroll direction, then
         animate to fx-in with a small per-word stagger. */
      var inTitle = titles[index];
      var inWords = inTitle.querySelectorAll('.fx-word-inner');
      inWords.forEach(function (w) {
        w.classList.remove('fx-in', 'fx-out-up', 'fx-out-down', 'fx-ready-below', 'fx-ready-above');
        w.classList.add(goingDown ? 'fx-ready-below' : 'fx-ready-above');
      });

      titles.forEach(function (t, i) {
        t.classList.toggle('fx-title--active', i === index);
      });

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          inWords.forEach(function (w, i) {
            setTimeout(function () {
              w.classList.remove('fx-ready-below', 'fx-ready-above');
              w.classList.add('fx-in');
            }, i * 60);
          });
        });
      });
    }

    function onScroll() {
      var rect = section.getBoundingClientRect();
      var scrollable = section.offsetHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var progress = Math.min(Math.max(-rect.top / scrollable, 0), 1);
      var target = Math.min(totalSlides - 1, Math.floor(progress * totalSlides));
      if (target !== currentIndex) setSlide(target);
    }

    /* Click left/right items to jump — smooth-scroll to the matching
       offset inside the sticky range so the section state stays in sync. */
    function scrollToSlide(index) {
      var sectionTop = window.scrollY + section.getBoundingClientRect().top;
      var scrollable = section.offsetHeight - window.innerHeight;
      var offset = (index / Math.max(totalSlides - 1, 1)) * scrollable;
      window.scrollTo({ top: sectionTop + offset, behavior: 'smooth' });
    }
    leftItems.forEach(function (item, i) {
      item.addEventListener('click', function () { scrollToSlide(i); });
    });
    rightItems.forEach(function (item, i) {
      item.addEventListener('click', function () { scrollToSlide(i); });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---- 3. SOCIAL FEEDBACK ---- */
  (function initSocialFeedback() {
    var section = document.querySelector('.social-feedback');
    if (!section) return;
    if (window.innerWidth <= 768) return;

    var texts = section.querySelectorAll('.sf-text');
    var cards = section.querySelectorAll('.social-card');
    var totalCards = cards.length;
    if (!totalCards) return;

    /* Final fan positions: [translateX(px), translateY(px), rotate(deg)] — left → right */
    var FINAL = [
      [-450, -20, -10],
      [-270, -10,   4],
      [ -90, -20,  -4],
      [  90,   0,   4],
      [ 270, -20,  -1],
      [ 450,   0,   0],
    ];

    /* Scroll progress windows */
    var TEXT_END = 0.18;     /* background text fades out by here */
    var CARDS_START = 0.18;  /* first card begins entering */
    var CARDS_END = 0.90;    /* last card finishes settling */

    /* Each card gets a staggered start; entries overlap so the motion feels continuous */
    var STAGGER = (CARDS_END - CARDS_START) / (totalCards + 1);
    var ENTRY_DURATION = STAGGER * 2.2;  /* >stagger → overlapping entries */

    /* Launch offset: how far LEFT of its final X each card starts (px).
       Short travel feels premium — opacity + scale carry most of the entry. */
    var LAUNCH_X_OFFSET = -260;
    var LAUNCH_Y_OFFSET = 40;        /* px below final Y at launch */
    var LAUNCH_SCALE = 0.86;
    var LAUNCH_ROT_DAMP = 0.4;       /* rotation starts at 40% of final, settles to 100% */

    function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }
    function clamp01(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }

    var ticking = false;

    function update() {
      ticking = false;
      var progress = getScrollProgress(section);

      /* Phase 1: text split (0 → TEXT_END) */
      var tp = clamp01(progress / TEXT_END);
      if (texts[0]) {
        texts[0].style.transform = 'translate3d(' + tp * 140 + 'px,0,0)';
        texts[0].style.opacity = 1 - tp;
      }
      if (texts[1]) {
        texts[1].style.opacity = 1 - tp;
      }
      if (texts[2]) {
        texts[2].style.transform = 'translate3d(' + tp * -140 + 'px,0,0)';
        texts[2].style.opacity = 1 - tp;
      }

      /* Phase 2: staggered card entry — each card slides in from the left
         and SETTLES at its final fan position (cards accumulate, don't exit) */
      cards.forEach(function (card, i) {
        var slot = FINAL[i] || FINAL[FINAL.length - 1];
        var finalX = slot[0];
        var finalY = slot[1];
        var finalRot = slot[2];

        var cardStart = CARDS_START + i * STAGGER;
        var cardEnd = cardStart + ENTRY_DURATION;

        var t;
        if (progress <= cardStart) t = 0;
        else if (progress >= cardEnd) t = 1;
        else t = easeOutQuart((progress - cardStart) / (cardEnd - cardStart));

        var startX = finalX + LAUNCH_X_OFFSET;
        var startY = finalY + LAUNCH_Y_OFFSET;
        var startRot = finalRot * LAUNCH_ROT_DAMP;

        var tx = startX + (finalX - startX) * t;
        var ty = startY + (finalY - startY) * t;
        var rot = startRot + (finalRot - startRot) * t;
        var scale = LAUNCH_SCALE + (1 - LAUNCH_SCALE) * t;
        var opacity = t;

        card.style.transform =
          'translate(-50%,-50%) translate3d(' + tx.toFixed(2) + 'px,' + ty.toFixed(2) + 'px,0)' +
          ' rotate(' + rot.toFixed(2) + 'deg)' +
          ' scale(' + scale.toFixed(3) + ')';
        card.style.opacity = opacity.toFixed(3);
        card.style.zIndex = 10 + i; /* latest entered card stays on top so its full video is visible */
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();
})();
